import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "clearfix"
}
const _hoisted_2 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_3 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_4 = { class: "d-sm-flex align-items-center" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_7 = { class: "row mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "position-relative" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "table-responsive" }
const _hoisted_12 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_13 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_14 = {
  key: 0,
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_15 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_16 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_17 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_18 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_19 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_21 = {
  key: 0,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_26 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_27 = {
  key: 0,
  class: "badge text-outline-info"
}
const _hoisted_28 = {
  key: 1,
  class: "badge text-outline-success"
}
const _hoisted_29 = {
  key: 2,
  class: "badge text-outline-danger"
}
const _hoisted_30 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_31 = { class: "dropdown" }
const _hoisted_32 = { class: "dropdown-menu" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "" }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "" }
const _hoisted_41 = { key: 2 }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "" }
const _hoisted_44 = {
  key: 0,
  class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
}
const _hoisted_45 = {
  key: 0,
  class: "mb-0 text-paragraph"
}
const _hoisted_46 = { class: "fw-bold" }
const _hoisted_47 = { class: "fw-bold" }
const _hoisted_48 = {
  key: 1,
  class: "mb-0 text-paragraph"
}
const _hoisted_49 = { class: "fw-bold" }
const _hoisted_50 = { class: "fw-bold" }
const _hoisted_51 = { class: "mt-15 mt-md-0" }
const _hoisted_52 = { class: "pagination mb-0" }
const _hoisted_53 = {
  key: 0,
  class: "page-item"
}
const _hoisted_54 = {
  key: 0,
  class: "page-link active",
  href: "#"
}
const _hoisted_55 = ["onClick"]
const _hoisted_56 = {
  key: 1,
  class: "page-item"
}
const _hoisted_57 = {
  class: "modal fade",
  id: "companyModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_58 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_59 = { class: "modal-content" }
const _hoisted_60 = { class: "modal-header" }
const _hoisted_61 = { class: "modal-title fs-5" }
const _hoisted_62 = { class: "modal-body" }
const _hoisted_63 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_64 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_65 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_66 = {
  key: 1,
  style: {"margin-top":"5%"}
}
const _hoisted_67 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"green"}
}
const _hoisted_68 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_69 = { class: "row" }
const _hoisted_70 = { class: "col-md-6" }
const _hoisted_71 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_72 = { class: "invalid-feedback" }
const _hoisted_73 = { class: "col-md-6" }
const _hoisted_74 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_75 = { value: "" }
const _hoisted_76 = ["value"]
const _hoisted_77 = { class: "row" }
const _hoisted_78 = { class: "col-md-12" }
const _hoisted_79 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_80 = ["placeholder"]
const _hoisted_81 = { class: "invalid-feedback" }
const _hoisted_82 = { class: "modal-footer" }
const _hoisted_83 = {
  type: "submit",
  class: "btn text-white",
  style: {"background-color":"#EB9355"}
}
const _hoisted_84 = {
  class: "modal fade",
  id: "detailModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_85 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_86 = { class: "modal-content" }
const _hoisted_87 = { class: "modal-header" }
const _hoisted_88 = { class: "modal-title fs-5" }
const _hoisted_89 = { class: "modal-body" }
const _hoisted_90 = { class: "row mb-15" }
const _hoisted_91 = { class: "col-md-6" }
const _hoisted_92 = { class: "d-block text-black fw-semibold mb-5" }
const _hoisted_93 = { class: "mb-0 text-black-emphasis" }
const _hoisted_94 = { class: "col-md-6" }
const _hoisted_95 = { class: "d-block text-black fw-semibold mb-5" }
const _hoisted_96 = { class: "mb-0 text-black-emphasis" }
const _hoisted_97 = {
  key: 0,
  class: "row mb-15"
}
const _hoisted_98 = { class: "col-md-12" }
const _hoisted_99 = { class: "d-block text-black fw-semibold mb-5" }
const _hoisted_100 = { class: "mb-0 text-black-emphasis" }
const _hoisted_101 = { class: "row mb-15" }
const _hoisted_102 = { class: "col-md-12" }
const _hoisted_103 = { class: "fw-bold mb-10" }
const _hoisted_104 = { class: "col-md-6" }
const _hoisted_105 = { class: "d-block text-black fw-semibold mb-5" }
const _hoisted_106 = { class: "mb-0 text-black-emphasis" }
const _hoisted_107 = { class: "col-md-6" }
const _hoisted_108 = { class: "mb-0 text-black-emphasis" }
const _hoisted_109 = { class: "col-md-6 mt-10" }
const _hoisted_110 = { class: "d-block text-black fw-semibold mb-5" }
const _hoisted_111 = { class: "mb-0 text-black-emphasis" }
const _hoisted_112 = { class: "row mb-15" }
const _hoisted_113 = { class: "col-md-12" }
const _hoisted_114 = { class: "fw-bold mb-10" }
const _hoisted_115 = { class: "col-md-6" }
const _hoisted_116 = { class: "d-block text-black fw-semibold mb-5" }
const _hoisted_117 = { class: "mb-0 text-black-emphasis" }
const _hoisted_118 = { class: "col-md-6" }
const _hoisted_119 = { class: "mb-0 text-black-emphasis" }
const _hoisted_120 = { class: "col-md-6 mt-10" }
const _hoisted_121 = { class: "d-block text-black fw-semibold mb-5" }
const _hoisted_122 = { class: "mb-0 text-black-emphasis" }
const _hoisted_123 = {
  key: 1,
  class: "col-md-12"
}
const _hoisted_124 = { class: "mb-0 text-muted" }
const _hoisted_125 = {
  key: 1,
  class: "row"
}
const _hoisted_126 = { class: "col-md-12" }
const _hoisted_127 = { class: "d-block text-black fw-semibold mb-5" }
const _hoisted_128 = {
  key: 0,
  class: "badge text-outline-info"
}
const _hoisted_129 = {
  key: 1,
  class: "badge text-outline-success"
}
const _hoisted_130 = {
  key: 2,
  class: "badge text-outline-danger"
}
const _hoisted_131 = { class: "modal-footer" }
const _hoisted_132 = {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}

import { ref, onMounted, reactive, inject, computed, watch } from "vue";
import axios from 'axios';
import router from '../../router/index'
import * as yup from 'yup';
import { useI18n } from "vue-i18n";
import { Country, Fee, Operator, Organization, TypeFree, Reloading, User } from "@/utils/Model";
import { current_permissions } from '../../utils/permission';
import { checkSessionValidate } from '../../utils/function';


export default /*@__PURE__*/_defineComponent({
  __name: 'ReloadingContent',
  setup(__props) {

const backApi = inject('back');
const { locale, t } = useI18n();

const selectedOperator = ref('');
const selectedCountry = ref('');
const selectedType = ref('');
const selectedMode = ref('');
const selectedUser = ref('');
const users = ref(new Array<User>());

const loader = ref(false);

let token: string | null = localStorage.getItem('login_token');
let codeOrganization: string | null = localStorage.getItem('organization_code');
let codeUser: string | null = localStorage.getItem('code');
let role: string | null = localStorage.getItem('role');

const countries = ref(new Array<Country>());
let edit = 0;
let itemCode = '';
let selectedOrganization = '';
let user = {} as User;
const operators = ref(new Array<Operator>());
const collectBalance = ref(0);
let balance: number = 0;
const typefees = ref(new Array<TypeFree>());
let operatorsTemp = new Array<Operator>();
let countriesTemp = new Array<Country>();
let data: any[] = [];

const errors = ref('');
const errorId = ref('');
const success = ref('');
const errorsBis = { 'amount': '', 'description': '' };
const pageLoad = ref(false);

const formValues = reactive({
  amount: "",
  description: ""
});

const detailReloading = ref<any>({});

const schema = yup.object({
  amount: yup.number().required('Le montant est requis'),
  description: yup.string().required('La description est requise'),
});

const allReloadings = ref<any[]>([]);

const searchQuery = ref('');
const page = ref(1);
const pageSize = ref(15);

const statusLabelOf = (status: string) =>
  status === 'DRAFT' ? t('reloadings.pending')
    : status === 'VALIDATED' ? t('reloadings.validated')
    : status === 'REJECTED' ? t('reloadings.rejected')
    : '';

const filteredReloadings = computed(() => {
  const q = searchQuery.value.trim().toLowerCase();
  if (!q) return allReloadings.value;
  return allReloadings.value.filter((r: any) => {
    const values = [
      r.code,
      r.description,
      r.amount,
      r.createdAt ? formatDateFr(new Date(r.createdAt)) : '',
      r.user?.name,
      r.organization?.name,
      statusLabelOf(r.status),
    ];
    return values.some(v => (v ?? '').toString().toLowerCase().includes(q));
  });
});

const filteredTotal = computed(() => filteredReloadings.value.length);
const numPages = computed(() => Math.max(1, Math.ceil(filteredTotal.value / pageSize.value)));

const showingFrom = computed(() => filteredTotal.value === 0 ? 0 : (page.value - 1) * pageSize.value + 1);
const showingTo = computed(() => Math.min(page.value * pageSize.value, filteredTotal.value));

const reloadings = computed(() => {
  const start = (page.value - 1) * pageSize.value;
  return filteredReloadings.value.slice(start, start + pageSize.value);
});

function handleAmountChange(event) {
  let withdrawAmount = event.target.value;
  if (parseFloat(withdrawAmount) <= 0) {
    formValues.amount = ''
  }
}

function handleTypeChange(event) {
  selectedType.value = event.target.value;
}
function handleUserChange(event) {
  selectedUser.value = event.target.value;
}

function formatDateFr(value) {
  if (value) {
    const year = value.getFullYear();
    let month = value.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    let day = value.getDate();
    day = day < 10 ? '0' + day : day;
    return day + '/' + month + '/' + year;
  }
}

const initField = () => {
  formValues.amount = '';
  formValues.description = '';
  itemCode = '';
  selectedOrganization = '';
  edit = 0;
}

const showReloadingDetail = (reloading) => {
  detailReloading.value = reloading;
}

const getUsers = (code) => {
  axios.get(`${backApi}/secure/users/?organization=${code}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      users.value = response.data;
    }).catch((error) => {
      if (error.response) {
        console.log(error.response.data);
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const fetchReloadingsPage = (targetPage: number) => {
  let baseUrl = '';
  if (
    role === 'SUPERADMIN' ||
    role === 'BUSINESS' ||
    role === 'SUPPORT'
  ) {
    baseUrl = `${backApi}/secure/topups/extended`;
  } else {
    baseUrl = `${backApi}/secure/topups/`;
    //baseUrl = `${backApi}/secure/topups/?organization=${codeOrganization}`;
  }
  const separator = baseUrl.includes('?') ? '&' : '?';
  const url = `${baseUrl}${separator}page=${targetPage}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache, no-store'
    }
  });
}

const loadAllReloadings = async () => {
  try {
    const first = await fetchReloadingsPage(1);
    const collected: any[] = [...first.data.data];
    const totalPages = first.data.pagination.numPages;

    if (totalPages > 1) {
      const remainingRequests = [];
      for (let p = 2; p <= totalPages; p++) {
        remainingRequests.push(fetchReloadingsPage(p));
      }
      const results = await Promise.all(remainingRequests);
      results.forEach(r => collected.push(...r.data.data));
    }

    allReloadings.value = collected;
    data = collected; 
    page.value = 1;
  } catch (error: any) {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

const goToPage = (targetPage: number) => {
  if (targetPage < 1 || targetPage > numPages.value || targetPage === page.value) return;
  page.value = targetPage;
}

// Revenir à la page 1 à chaque nouvelle recherche.
watch(searchQuery, () => {
  page.value = 1;
});

const showReloading = (code) => {
  axios.get(backApi + '/secure/topups/' + code + '/show', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      formValues.amount = response.data.amount;
      formValues.description = response.data.description;
      itemCode = response.data.code;
      selectedOrganization = response.data.organization.code;
      edit = 1;
      console.log(response.data);
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          console.log(error.response);
        }
      }
    });
}

const getBalanceCollect = () => {
  axios.post(backApi + `/secure/accounts/balance/available`, {
    code: codeOrganization,
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
    .then((response) => {
      collectBalance.value = response.data.availableBalance;
      balance = response.data.availableBalance;
      console.log(response.data);
    }).catch((error) => {
      if (error.response) {
        console.log(error.response.data);
        if (error.response.status === 401) {
          router.push('/')
        }
      }
    });
}

const changeStatus = (status, code) => {
  axios.put(`${backApi}/secure/topups/status`, {
    code: code,
    status: status
  }, {
    headers: {
      Authorization: `Bearer ${token}`,
    }
  }).then((response) => {
    router.go();
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

const save = () => {
  if (edit == 0) {
    storeReloading()
  } else {
    updateReloading()
  }
}

const storeReloading = () => {
  try {
    schema.validateSync(formValues);
    axios.post(`${backApi}/secure/topups/new`, {
      amount: parseFloat(formValues.amount),
      description: formValues.description,
      organization: codeOrganization,
      user: (selectedUser.value == '') ? null : selectedUser.value,
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      if (response.status === 200) {
        router.go();
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
    });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
  }
}

const updateReloading = () => {
  try {
    schema.validateSync(formValues);
    axios.put(`${backApi}/secure/topups/${itemCode}/edit`, {
      amount: parseFloat(formValues.amount),
      description: formValues.description,
      code: itemCode,
      organization: selectedOrganization
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      edit = 0;
      itemCode = '';
      selectedOrganization = '';
      if (response.status === 200) {
        router.go();
      }
    }).catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')
        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }
      }
    });
  } catch (error) {
    errors.value = "une erreur inattendue est apparue"
  }
}

function validate(field) {
  schema
    .validateAt(field, formValues)
    .then(() => {
      errorsBis[field] = "";
    })
    .catch(err => {
      errorsBis[field] = err.message;
    });
  errors.value = ''
}

const exportExcel = () => {
  import("../../utils/Export2Excel").then((excel) => {
    const Header = ["CODE RECHARGEMENT", "DESCRIPTION", "MONTANT", "DATE", "STATUT"];
    const Fields = ["code", "description", "amount", "createdAt", "status"];
    const dataForExcel = formatJSon(Fields, data);
    excel.export_json_to_excel({
      header: Header,
      data: dataForExcel,
      sheetName: "Feuil1",
      filename: "rechargement",
      autoWidth: true,
      bookType: "xlsx",
    });
  });
}

function formatJSon(FilterData, JsonData) {
  return JsonData.map((v) => FilterData.map(j => {
    return v[j];
  }));
}

onMounted(async () => {
  checkSessionValidate(1)
  loadAllReloadings();
  getBalanceCollect();
  getUsers(codeOrganization);

  setTimeout(function () {
    pageLoad.value = true;
  }, 1000)
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[8] || (_cache[8] = [
          _createElementVNode("div", {
            class: "spinner-grow text-danger",
            style: {"width":"3rem","height":"3rem","margin-top":"25vh","margin-left":"42%","margin-bottom":"5vh"},
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_unref(current_permissions)('export_transactions'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "default-outline-btn text-black bg-transparent position-relative transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block mb-10 mb-lg-0",
                    type: "button",
                    onClick: exportExcel
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('reloadings.excel')) + " ", 1),
                    _cache[9] || (_cache[9] = _createElementVNode("i", { class: "flaticon-file-1 position-relative ms-5 top-2 fs-15" }, null, -1))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_unref(current_permissions)('create_topup'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                    type: "button",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#companyModal",
                    style: {"background-color":"#EB9355"},
                    onClick: initField
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('reloadings.createRequest')) + " ", 1),
                    _cache[10] || (_cache[10] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                    type: "text",
                    class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                    placeholder: _ctx.$t('reloadings.search')
                  }, null, 8, _hoisted_10), [
                    [_vModelText, searchQuery.value]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("table", _hoisted_12, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('reloadings.code')), 1),
                    (_unref(current_permissions)('SUPERADMIN'))
                      ? (_openBlock(), _createElementBlock("th", _hoisted_14, _toDisplayString(_ctx.$t('reloadings.organization')), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('reloadings.description')), 1),
                    _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('reloadings.amount')), 1),
                    _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t('reloadings.date')), 1),
                    _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t('reloadings.attachedTo')), 1),
                    _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t('reloadings.status')), 1),
                    _cache[11] || (_cache[11] = _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    }, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reloadings.value, (reloading) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: reloading.code
                    }, [
                      _createElementVNode("td", _hoisted_20, _toDisplayString(reloading.code), 1),
                      (_unref(current_permissions)('SUPERADMIN'))
                        ? (_openBlock(), _createElementBlock("td", _hoisted_21, _toDisplayString(reloading.organization.name), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_22, _toDisplayString(reloading.description), 1),
                      _createElementVNode("td", _hoisted_23, _toDisplayString(reloading.amount), 1),
                      _createElementVNode("td", _hoisted_24, _toDisplayString(formatDateFr(new Date(reloading.createdAt))), 1),
                      _createElementVNode("td", _hoisted_25, _toDisplayString(reloading.user?.name), 1),
                      _createElementVNode("td", _hoisted_26, [
                        (reloading.status==='DRAFT')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.$t('reloadings.pending')), 1))
                          : _createCommentVNode("", true),
                        (reloading.status==='VALIDATED')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.$t('reloadings.validated')), 1))
                          : _createCommentVNode("", true),
                        (reloading.status==='REJECTED')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.$t('reloadings.rejected')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _cache[16] || (_cache[16] = _createElementVNode("button", {
                            class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                            type: "button",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false"
                          }, [
                            _createElementVNode("i", { class: "flaticon-dots" })
                          ], -1)),
                          _createElementVNode("ul", _hoisted_32, [
                            _createElementVNode("li", null, [
                              _createElementVNode("a", {
                                class: "dropdown-item d-flex align-items-center",
                                href: "javascript:void(0);",
                                onClick: ($event: any) => (showReloadingDetail(reloading)),
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#detailModal"
                              }, [
                                _cache[12] || (_cache[12] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                                _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t('reloadings.details')), 1)
                              ], 8, _hoisted_33)
                            ]),
                            (reloading.status==='DRAFT')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (_unref(current_permissions)('status_topup'))
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_35, [
                                        _createElementVNode("a", {
                                          class: "dropdown-item d-flex align-items-center",
                                          style: {"color":"red"},
                                          href: "javascript:void(0);",
                                          onClick: ($event: any) => (changeStatus('REJECTED',reloading.code))
                                        }, [
                                          _cache[13] || (_cache[13] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                                          _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.$t('reloadings.reject')), 1)
                                        ], 8, _hoisted_36)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_unref(current_permissions)('status_topup'))
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_38, [
                                        _createElementVNode("a", {
                                          class: "dropdown-item d-flex align-items-center",
                                          style: {"color":"green"},
                                          href: "javascript:void(0);",
                                          onClick: ($event: any) => (changeStatus('VALIDATED',reloading.code))
                                        }, [
                                          _cache[14] || (_cache[14] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                                          _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t('reloadings.validate')), 1)
                                        ], 8, _hoisted_39)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_unref(current_permissions)('show_topup'))
                                    ? (_openBlock(), _createElementBlock("li", _hoisted_41, [
                                        _createElementVNode("a", {
                                          class: "dropdown-item d-flex align-items-center",
                                          style: {"color":"red"},
                                          href: "javascript:void(0);",
                                          onClick: ($event: any) => (showReloading(reloading.code)),
                                          "data-bs-toggle": "modal",
                                          "data-bs-target": "#companyModal"
                                        }, [
                                          _cache[15] || (_cache[15] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                                          _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t('reloadings.edit')), 1)
                                        ], 8, _hoisted_42)
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            (filteredTotal.value>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  (filteredTotal.value>pageSize.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_45, [
                        _createTextVNode(_toDisplayString(_ctx.$t('reloadings.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_46, _toDisplayString(showingFrom.value) + "-" + _toDisplayString(showingTo.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('reloadings.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_47, _toDisplayString(filteredTotal.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('reloadings.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (filteredTotal.value<=pageSize.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_48, [
                        _createTextVNode(_toDisplayString(_ctx.$t('reloadings.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_49, _toDisplayString(filteredTotal.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('reloadings.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_50, _toDisplayString(filteredTotal.value), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('reloadings.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("nav", _hoisted_51, [
                    _createElementVNode("ul", _hoisted_52, [
                      ((page.value-1)>0)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_53, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (goToPage(page.value-1))),
                              "aria-label": "Previous"
                            }, [...(_cache[17] || (_cache[17] = [
                              _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numPages.value, (numPage) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: numPage,
                          class: "page-item"
                        }, [
                          (numPage==page.value)
                            ? (_openBlock(), _createElementBlock("a", _hoisted_54, _toDisplayString(numPage), 1))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "page-link",
                                onClick: ($event: any) => (goToPage(numPage))
                              }, _toDisplayString(numPage), 9, _hoisted_55))
                        ]))
                      }), 128)),
                      ((page.value+1)<=numPages.value)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_56, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (goToPage(page.value+1))),
                              "aria-label": "Next"
                            }, [...(_cache[18] || (_cache[18] = [
                              _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_57, [
      _createElementVNode("div", _hoisted_58, [
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(save, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("h1", _hoisted_61, _toDisplayString(_ctx.$t('reloadings.reloadRequest')), 1),
              _cache[19] || (_cache[19] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_62, [
              (errors.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                    _createElementVNode("h6", _hoisted_64, _toDisplayString(errorId.value), 1),
                    _createElementVNode("h6", _hoisted_65, _toDisplayString(errors.value), 1)
                  ]))
                : _createCommentVNode("", true),
              (success.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
                    _createElementVNode("h6", _hoisted_67, _toDisplayString(success.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_68, [
                _createElementVNode("div", _hoisted_69, [
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.$t('reloadings.amount')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        onKeyup: handleAmountChange,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formValues.amount) = $event)),
                        type: "number",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['amount'] }]),
                        id: "lead-calendar",
                        placeholder: "2",
                        onBlur: _cache[4] || (_cache[4] = ($event: any) => (validate('amount')))
                      }, null, 34), [
                        [_vModelText, formValues.amount]
                      ]),
                      _createElementVNode("span", _hoisted_72, _toDisplayString(errorsBis['amount']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("label", _hoisted_74, _toDisplayString(_ctx.$t('reloadings.users')), 1),
                    _createElementVNode("select", {
                      name: "mode",
                      id: "mode",
                      class: "form-select fs-md-15 text-black shadow-none",
                      onChange: handleUserChange
                    }, [
                      _createElementVNode("option", _hoisted_75, _toDisplayString(_ctx.$t('reloadings.select')), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: user.code,
                          key: user.code
                        }, _toDisplayString(user.name), 9, _hoisted_76))
                      }), 128))
                    ], 32)
                  ])
                ]),
                _createElementVNode("div", _hoisted_77, [
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("label", _hoisted_79, _toDisplayString(_ctx.$t('reloadings.description')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formValues.description) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['description'] }]),
                        id: "lead-calendar",
                        placeholder: _ctx.$t('reloadings.descriptionPlaceholder'),
                        onBlur: _cache[6] || (_cache[6] = ($event: any) => (validate('description'))),
                        onKeyup: _cache[7] || (_cache[7] = ($event: any) => (validate('description')))
                      }, "                    ", 42, _hoisted_80), [
                        [_vModelText, formValues.description]
                      ]),
                      _createElementVNode("span", _hoisted_81, _toDisplayString(errorsBis['description']), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_82, [
              _createElementVNode("button", _hoisted_83, [
                _cache[20] || (_cache[20] = _createElementVNode("i", {
                  class: "flaticon-plus position-relative ms-5 fs-12",
                  style: {"color":"#FFF"}
                }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('reloadings.save')), 1)
              ])
            ])
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_84, [
      _createElementVNode("div", _hoisted_85, [
        _createElementVNode("div", _hoisted_86, [
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("h1", _hoisted_88, _toDisplayString(_ctx.$t('reloadings.details')), 1),
            _cache[21] || (_cache[21] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("div", _hoisted_90, [
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("label", _hoisted_92, _toDisplayString(_ctx.$t('reloadings.code')), 1),
                _createElementVNode("p", _hoisted_93, _toDisplayString(detailReloading.value.code), 1)
              ]),
              _createElementVNode("div", _hoisted_94, [
                _createElementVNode("label", _hoisted_95, _toDisplayString(_ctx.$t('reloadings.amount')), 1),
                _createElementVNode("p", _hoisted_96, _toDisplayString(detailReloading.value.amount), 1)
              ])
            ]),
            (detailReloading.value.description)
              ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("label", _hoisted_99, _toDisplayString(_ctx.$t('reloadings.description')), 1),
                    _createElementVNode("p", _hoisted_100, _toDisplayString(detailReloading.value.description), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _cache[24] || (_cache[24] = _createElementVNode("hr", null, null, -1)),
            _createElementVNode("div", _hoisted_101, [
              _createElementVNode("div", _hoisted_102, [
                _createElementVNode("h6", _hoisted_103, _toDisplayString(_ctx.$t('reloadings.createdBy')), 1)
              ]),
              _createElementVNode("div", _hoisted_104, [
                _createElementVNode("label", _hoisted_105, _toDisplayString(_ctx.$t('reloadings.name')), 1),
                _createElementVNode("p", _hoisted_106, _toDisplayString(detailReloading.value.createdBy?.name || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_107, [
                _cache[22] || (_cache[22] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-5" }, "Email", -1)),
                _createElementVNode("p", _hoisted_108, _toDisplayString(detailReloading.value.createdBy?.email || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_109, [
                _createElementVNode("label", _hoisted_110, _toDisplayString(_ctx.$t('reloadings.date')), 1),
                _createElementVNode("p", _hoisted_111, _toDisplayString(detailReloading.value.createdAt ? formatDateFr(new Date(detailReloading.value.createdAt)) : '-'), 1)
              ])
            ]),
            _cache[25] || (_cache[25] = _createElementVNode("hr", null, null, -1)),
            _createElementVNode("div", _hoisted_112, [
              _createElementVNode("div", _hoisted_113, [
                _createElementVNode("h6", _hoisted_114, _toDisplayString(_ctx.$t('reloadings.validatedBy')), 1)
              ]),
              (detailReloading.value.validatedBy)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_115, [
                      _createElementVNode("label", _hoisted_116, _toDisplayString(_ctx.$t('reloadings.name')), 1),
                      _createElementVNode("p", _hoisted_117, _toDisplayString(detailReloading.value.validatedBy?.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_118, [
                      _cache[23] || (_cache[23] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-5" }, "Email", -1)),
                      _createElementVNode("p", _hoisted_119, _toDisplayString(detailReloading.value.validatedBy?.email), 1)
                    ]),
                    _createElementVNode("div", _hoisted_120, [
                      _createElementVNode("label", _hoisted_121, _toDisplayString(_ctx.$t('reloadings.date')), 1),
                      _createElementVNode("p", _hoisted_122, _toDisplayString(detailReloading.value.validatedAt ? formatDateFr(new Date(detailReloading.value.validatedAt)) : '-'), 1)
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_123, [
                    _createElementVNode("p", _hoisted_124, _toDisplayString(_ctx.$t('reloadings.notValidatedYet')), 1)
                  ]))
            ]),
            (detailReloading.value.status)
              ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                  _createElementVNode("div", _hoisted_126, [
                    _createElementVNode("label", _hoisted_127, _toDisplayString(_ctx.$t('reloadings.status')), 1),
                    (detailReloading.value.status==='DRAFT')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_128, _toDisplayString(_ctx.$t('reloadings.pending')), 1))
                      : _createCommentVNode("", true),
                    (detailReloading.value.status==='VALIDATED')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_129, _toDisplayString(_ctx.$t('reloadings.validated')), 1))
                      : _createCommentVNode("", true),
                    (detailReloading.value.status==='REJECTED')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_130, _toDisplayString(_ctx.$t('reloadings.rejected')), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_131, [
            _createElementVNode("button", _hoisted_132, _toDisplayString(_ctx.$t('reloadings.close')), 1)
          ])
        ])
      ])
    ])
  ], 64))
}
}

})